module.exports = __webpack_public_path__ + "static/media/purewatt-4.aefd5642.jpg";